import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppSharedModule } from '../shared/app-shared.module';
import { ThemeRoutingModule } from './theme.routing';

import { MaterializeModule } from 'angular2-materialize';

import { ThemeService } from "./theme.service";
import { NotificationsService } from '../shared/notifications.service';
import { ThemeComponent } from './theme.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';

import { PushNotificationsService } from './../push-notifications.service';

@NgModule({
  imports: [
    AppSharedModule,
    ThemeRoutingModule,
    MaterializeModule,
    CommonModule
  ],
  providers: [ThemeService,NotificationsService,PushNotificationsService],
  declarations: [ThemeComponent, HeaderComponent, SidebarComponent, BreadcrumbsComponent]
})
export class ThemeModule { }



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/theme/theme.module.ts